// LIBRARIES
import { createAsyncThunk } from "@reduxjs/toolkit";

// MISC
import { REST } from "config/axiosConfig";
import { IAuthentificationPayload, IGetUserPayload } from "models/interfaces";

export const authenticate = createAsyncThunk(
  "session/authenticate",
  async (data: IAuthentificationPayload, { rejectWithValue }) => {
    try {
      const response = await REST.post("/auth/login", data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const getUser = createAsyncThunk(
  "user/getUser",
  async (username: IGetUserPayload) => {
    try {
      const response = await REST.post("/user/get-user", username);
      return response.data;
    } catch (err) {
      return err;
    }
  }
);
